import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const GeneralSettings = lazyLoader(
  () => import("Containers/Settings/GeneralSettings/GeneralSetting")
);

export const GeneralSetting = () => {
  return (
    <Layout>
      <GeneralSettings />
    </Layout>
  );
};
